import api from './api';

const resource = 'Referral/';

// The API (ReferralController) resolves a requested `companyid` against the
// user's memberships; without one it serves the user's first company. So the
// company selected in the changer is sent whenever there is one, and nothing at
// all when there is none (admins carry no selected company).
const companyQuery = (companyid, joiner) =>
  companyid ? `${joiner}companyid=${encodeURIComponent(companyid)}` : '';

export const me = async (companyid) => {
  return await api.get(resource + 'Me' + companyQuery(companyid, '?'));
};

// `query` already starts with '?'.
export const history = async (query, companyid) => {
  return await api.get(resource + 'History' + query + companyQuery(companyid, '&'));
};

export const ledger = async (companyid) => {
  return await api.get(resource + 'Ledger' + companyQuery(companyid, '?'));
};

// shareSms / shareEmail: the caller puts `companyid` in the body.
export const shareSms = async (body) => {
  return await api.post(resource + 'ShareSms', body);
};

export const shareEmail = async (body) => {
  return await api.post(resource + 'ShareEmail', body);
};

export const validate = async (code) => {
  return await api.get(resource + 'Validate?code=' + encodeURIComponent(code));
};

// Kayıt sırasında kod girmeyen davet edilen restoran, davet eden kodunu
// dashboard'dan sonradan ekler. body { code } (admin için { companyid, code }).
export const applyCode = async (body) => {
  return await api.post(resource + 'ApplyCode', body);
};

const referralApi = {
  me,
  history,
  ledger,
  shareSms,
  shareEmail,
  validate,
  applyCode,
};

export default referralApi;
